import { SupplierRegistrationCountryFields } from '@supplierRegistration/domain/supplierRegistrationCountryFields';
import { ConditionalValidationRule } from '@app/utils/form/form';
import { trim } from '@app/utils/stringUtils';

export enum ArgentinaLegalIdTypesForCompany {
  CUIT = 'CUIT',
}

function getAdditionalSwiftRules(): ConditionalValidationRule[] {
  return [
    {
      required: true,
      transform: trim,
      translatedMessage: 'supplierValidation.supplierRegister.errors.missingSwift',
    },
  ];
}

export const AR: SupplierRegistrationCountryFields = {
  leis: { types: ArgentinaLegalIdTypesForCompany, defaultValue: ArgentinaLegalIdTypesForCompany.CUIT },
  swiftCodeAdditionalRules: getAdditionalSwiftRules,
};
